import React, { Component, createContext } from 'react';
import { withRouter } from 'next/router';
import Cookies from 'js-cookie';
import { isString, template } from 'helpers/lodash';

import Languages from '../../translations';

const DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE || 'en';

const LanguageContext = createContext(null);

class LanguageProvider extends Component {
	state = {
		selectedLang: this.props.router.locale || Cookies.get('lang') || DEFAULT_LANGUAGE,
		languages: Languages,
	};

	methods = {
		selectLanguage: this.selectLanguage.bind(this),
		translate: this.translate.bind(this),
	};

	componentDidMount() {
		const initialLang = this.props.router.locale || this.state.selectedLang || DEFAULT_LANGUAGE;
		this.updateDocumentLanguageAttributes(initialLang);
		this.selectLanguage(initialLang);
	}

	componentDidUpdate(prevProps) {
		if (this.props.router.locale !== prevProps.router.locale) {
			this.selectLanguage(this.props.router.locale);
		}
	}

	getLanguageParams(lang) {
		return this.state.languages[lang].params;
	}

	selectLanguage(lang) {
		const nextLang = this.state.languages[lang] ? lang : DEFAULT_LANGUAGE;

		this.setState({ selectedLang: nextLang }, () => {
			Cookies.set('lang', nextLang);
			this.updateDocumentLanguageAttributes(nextLang);
		});
	}

	updateDocumentLanguageAttributes(lang) {
		if (typeof document === 'undefined') {
			return;
		}

		const htmlElement = document.documentElement;
		if (!htmlElement) {
			return;
		}

		htmlElement.setAttribute('lang', lang || DEFAULT_LANGUAGE);
		htmlElement.classList.toggle('lang-hy', lang === 'hy');
	}

	translate(val, vars) {
		const compiled = isString(val) && this.state.languages[this.state.selectedLang]?.[val] && template(this.state.languages[this.state.selectedLang][val]);
		return (compiled && compiled(vars)) || val || 'Please Set Translate Value';
	}

	render() {
		return <LanguageContext.Provider value={{ ...this.state, ...this.methods }}>{this.props.children}</LanguageContext.Provider>;
	}
}

export default withRouter(LanguageProvider);
export const LanguageConsumer = LanguageContext.Consumer;
